import { render, staticRenderFns } from "./mobile-app.vue?vue&type=template&id=da6127b6"
import script from "./mobile-app.vue?vue&type=script&lang=js"
export * from "./mobile-app.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./locale/mobile-app-en.json?vue&type=custom&index=0&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fmobile-app.vue&locale=en&external"
if (typeof block0 === 'function') block0(component)
import block1 from "./locale/mobile-app-ar.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Fvercel%2Fpath0%2Fpages%2Finvesting%2Fservices%2Fmobile-app.vue&locale=ar&external"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {AppStoreLinks: require('/vercel/path0/components/blocks/AppStoreLinks.vue').default,CImage: require('/vercel/path0/components/ui/c-image.vue').default,VideoThumbnailCard: require('/vercel/path0/components/ui/VideoThumbnailCard.vue').default,AppFeaturesCarousel: require('/vercel/path0/components/blocks/AppFeaturesCarousel.vue').default,Decorator: require('/vercel/path0/components/ui/decorator.vue').default})
